// Applications data with slugs for SEO-friendly URLs

export const applications = [
  {
    id: 'progenx-academy',
    slug: 'progenx-academy',
    title: 'ProgenX Academy',
    description: 'Eğitim teknolojileri uygulaması',
    shortDescription: 'Yapay zeka destekli kişiselleştirilmiş öğrenme platformu',
    category: 'Eğitim Teknolojileri',
    url: 'https://app.progenxacademy.com',
    icon: 'academy',
    isPopular: true,
    isNew: false,
    content: `ProgenX Academy, yapay zeka destekli kişiselleştirilmiş öğrenme deneyimi sunan, öğrencilerin bireysel öğrenme ihtiyaçlarına göre optimize edilmiş eğitim programları oluşturan yenilikçi bir platformdur.

<h3 style="color: var(--primary-color); margin: 25px 0 15px;">🎯 Özellikler:</h3>
<ul style="list-style-type: none; padding-left: 0;">
  <li style="margin-bottom: 10px;">• Yapay zeka destekli kişiselleştirilmiş öğrenme yolları</li>
  <li style="margin-bottom: 10px;">• Akıllı soru çözüm sistemi ve anında geri bildirim</li>
  <li style="margin-bottom: 10px;">• Detaylı ilerleme takibi ve performans analizi</li>
  <li style="margin-bottom: 10px;">• Öğrenciye özel öğrenme planları</li>
  <li style="margin-bottom: 10px;">• Eğlenceli ve interaktif içerikler</li>
</ul>

ProgenX Academy ile her öğrenci kendi hızında öğrenir ve potansiyelini maksimuma çıkarır.`,
    tags: ['Eğitim', 'Yapay Zeka', 'Kişiselleştirilmiş Öğrenme', 'EdTech'],
    faqs: [
      {
        question: 'ProgenX Academy nedir?',
        answer: 'ProgenX Academy, yapay zeka destekli kişiselleştirilmiş öğrenme platformudur. Öğrencilerin bireysel ihtiyaçlarına göre öğrenme yolları oluşturur ve akıllı geri bildirimler sunar.'
      },
      {
        question: 'ProgenX Academy nasıl çalışır?',
        answer: 'Platform, öğrencinin performansını analiz ederek kişiselleştirilmiş öğrenme planları oluşturur. Yapay zeka teknolojisi sayesinde her öğrenci kendi hızında ve tarzında öğrenir.'
      }
    ]
  },
  {
    id: 'ozel-ders',
    slug: 'ozel-ders-platformu',
    title: 'Özel Ders Platformu',
    description: 'Özel ders arayan öğrenciler ve öğretmenleri bir araya getiren platform',
    shortDescription: 'Özel ders arayan öğrenciler ve öğretmenleri buluşturan platform',
    category: 'Eğitim Platformu',
    url: 'https://tutor.progenxacademy.com',
    icon: 'tutor',
    isPopular: false,
    isNew: true,
    content: `Özel Ders Platformu, özel ders arayan öğrenciler ile öğretmenleri buluşturan, güvenilir ve etkili bir eğitim çözümü sunan platformdur.

<h3 style="color: var(--primary-color); margin: 25px 0 15px;">🎯 Özellikler:</h3>
<ul style="list-style-type: none; padding-left: 0;">
  <li style="margin-bottom: 10px;">• Öğrenci ve öğretmen eşleştirme sistemi</li>
  <li style="margin-bottom: 10px;">• Güvenilir öğretmen profilleri ve değerlendirmeleri</li>
  <li style="margin-bottom: 10px;">• Esnek ders programlama</li>
  <li style="margin-bottom: 10px;">• Online ve yüz yüze ders seçenekleri</li>
  <li style="margin-bottom: 10px;">• Güvenli ödeme sistemi</li>
</ul>

Özel Ders Platformu ile öğrenciler ihtiyaçlarına uygun öğretmenleri bulur, öğretmenler ise öğrencilerine ulaşır.`,
    tags: ['Özel Ders', 'Eğitim', 'Platform', 'Öğretmen'],
    faqs: [
      {
        question: 'Özel Ders Platformu nasıl çalışır?',
        answer: 'Platform, öğrencilerin ihtiyaçlarını ve öğretmenlerin uzmanlık alanlarını eşleştirir. Öğrenciler uygun öğretmenleri bulabilir, öğretmenler ise öğrencilerine ulaşabilir.'
      }
    ]
  },
  {
    id: 'ib-egitimi',
    slug: 'ib-egitimi-platformu',
    title: 'IB Eğitimi Platformu',
    description: 'IB eğitimi ile ilgili kapsamlı platform',
    shortDescription: 'IB eğitimi için özel olarak tasarlanmış platform',
    category: 'Yurtdışı Eğitimi',
    url: 'https://ib.progenxacademy.com',
    icon: 'ib',
    isPopular: false,
    isNew: false,
    content: `IB Eğitimi Platformu, International Baccalaureate (IB) programı öğrencileri ve öğretmenleri için özel olarak tasarlanmış kapsamlı bir eğitim platformudur.

<h3 style="color: var(--primary-color); margin: 25px 0 15px;">🎯 Özellikler:</h3>
<ul style="list-style-type: none; padding-left: 0;">
  <li style="margin-bottom: 10px;">• IB müfredatına uygun içerikler</li>
  <li style="margin-bottom: 10px;">• IB sınavlarına hazırlık materyalleri</li>
  <li style="margin-bottom: 10px;">• IB öğretmenleri için kaynaklar</li>
  <li style="margin-bottom: 10px;">• IB öğrencileri için destek araçları</li>
</ul>

IB Eğitimi Platformu ile IB programı öğrencileri ve öğretmenleri ihtiyaç duydukları tüm kaynaklara tek bir yerden erişir.`,
    tags: ['IB', 'International Baccalaureate', 'Eğitim', 'Platform'],
    faqs: [
      {
        question: 'IB Eğitimi Platformu kimler için?',
        answer: 'IB Eğitimi Platformu, IB programı öğrencileri, öğretmenleri ve IB eğitimi almak isteyen herkes için tasarlanmıştır.'
      }
    ]
  },
  {
    id: 'chess',
    slug: 'progenx-chess',
    title: 'ProgenX Chess',
    description: 'Satranç oyunu',
    shortDescription: 'Eğitici ve eğlenceli satranç uygulaması',
    category: 'Oyun',
    url: 'http://chess.progenxacademy.com',
    icon: 'chess',
    isPopular: false,
    isNew: true,
    content: `ProgenX Chess, satranç öğrenmek ve geliştirmek isteyen herkes için tasarlanmış eğitici ve eğlenceli bir satranç uygulamasıdır.

<h3 style="color: var(--primary-color); margin: 25px 0 15px;">🎯 Özellikler:</h3>
<ul style="list-style-type: none; padding-left: 0;">
  <li style="margin-bottom: 10px;">• Satranç öğrenme modülleri</li>
  <li style="margin-bottom: 10px;">• Farklı seviyelerde bilgisayar rakipleri</li>
  <li style="margin-bottom: 10px;">• Online oyuncularla maç yapma</li>
  <li style="margin-bottom: 10px;">• Satranç taktikleri ve stratejileri</li>
  <li style="margin-bottom: 10px;">• İlerleme takibi ve istatistikler</li>
</ul>

ProgenX Chess ile satranç öğrenin, pratik yapın ve kendinizi geliştirin.`,
    tags: ['Satranç', 'Oyun', 'Eğitim', 'Eğlence'],
    faqs: [
      {
        question: 'ProgenX Chess kimler için uygun?',
        answer: 'ProgenX Chess, satranç öğrenmek isteyen başlangıç seviyesindeki oyuncular ve kendini geliştirmek isteyen deneyimli oyuncular için uygundur.'
      }
    ]
  },
  {
    id: 'kids',
    slug: 'progenx-kids',
    title: 'ProgenX Kids',
    description: 'Çocuklar için eğitim uygulaması',
    shortDescription: 'Çocuklar için eğlenceli ve eğitici uygulama',
    category: 'Çocuk Eğitimi',
    url: 'http://kids.progenxacademy.com',
    icon: 'kids',
    isPopular: false,
    isNew: true,
    content: `ProgenX Kids, çocuklar için özel olarak tasarlanmış eğlenceli ve eğitici bir uygulamadır. Çocukların öğrenirken eğlenmesini sağlar.

<h3 style="color: var(--primary-color); margin: 25px 0 15px;">🎯 Özellikler:</h3>
<ul style="list-style-type: none; padding-left: 0;">
  <li style="margin-bottom: 10px;">• Yaşa uygun eğitici içerikler</li>
  <li style="margin-bottom: 10px;">• Eğlenceli oyunlar ve aktiviteler</li>
  <li style="margin-bottom: 10px;">• Güvenli ve çocuk dostu arayüz</li>
  <li style="margin-bottom: 10px;">• Ebeveyn kontrol paneli</li>
  <li style="margin-bottom: 10px;">• İnteraktif öğrenme deneyimleri</li>
</ul>

ProgenX Kids ile çocuklarınız eğlenirken öğrenir ve gelişir.`,
    tags: ['Çocuk', 'Eğitim', 'Oyun', 'Eğlence'],
    faqs: [
      {
        question: 'ProgenX Kids hangi yaş grubu için?',
        answer: 'ProgenX Kids, okul öncesi ve ilkokul çağındaki çocuklar için tasarlanmıştır. Yaşa uygun içerikler ve aktiviteler sunar.'
      }
    ]
  },
  {
    id: 'program',
    slug: 'ders-programi-platformu',
    title: 'Ders Programı Platformu',
    description: 'Okulların kendi programlarını oluşturabilecekleri platform',
    shortDescription: 'Okullar için ders programı oluşturma platformu',
    category: 'Okul Yönetimi',
    url: 'https://program.progenxacademy.com',
    icon: 'program',
    isPopular: false,
    isNew: false,
    content: `Ders Programı Platformu, okulların öğretmen ve sınıflar için ders programlarını kolayca oluşturabilecekleri, yönetebilecekleri ve optimize edebilecekleri bir platformdur.

<h3 style="color: var(--primary-color); margin: 25px 0 15px;">🎯 Özellikler:</h3>
<ul style="list-style-type: none; padding-left: 0;">
  <li style="margin-bottom: 10px;">• Otomatik ders programı oluşturma</li>
  <li style="margin-bottom: 10px;">• Öğretmen ve sınıf yönetimi</li>
  <li style="margin-bottom: 10px;">• Çakışma kontrolü ve optimizasyon</li>
  <li style="margin-bottom: 10px;">• Esnek program düzenleme</li>
  <li style="margin-bottom: 10px;">• Raporlama ve analiz araçları</li>
</ul>

Ders Programı Platformu ile okullar ders programlarını verimli bir şekilde yönetir ve öğretmen-öğrenci uyumunu optimize eder.`,
    tags: ['Okul', 'Ders Programı', 'Yönetim', 'Platform'],
    faqs: [
      {
        question: 'Ders Programı Platformu nasıl çalışır?',
        answer: 'Platform, okulların öğretmen, sınıf ve ders bilgilerini alarak otomatik olarak optimize edilmiş ders programları oluşturur. Çakışmaları önler ve en verimli programı sunar.'
      }
    ]
  },
  {
    id: 'yayinevi-kitap',
    slug: 'yayinevi-kitap-uygulamasi',
    title: 'Yayınevleri İçin Örnek Kitap Uygulaması',
    description: 'Yayınevi admin panelden kitap yükleyip belirli bir kısmını seçip link oluşturup öğretmenlere kitabın incelemeleri için dijital versiyonunu gönderiyor',
    shortDescription: 'Yayınevleri için dijital kitap inceleme platformu',
    category: 'Yayınevi Çözümleri',
    url: 'https://dijital.progenxacademy.com/',
    icon: 'publisher',
    isPopular: true,
    isNew: false,
    content: `Yayınevleri İçin Örnek Kitap Uygulaması, yayınevlerinin kitaplarını dijital ortamda öğretmenlere sunmalarını sağlayan yenilikçi bir platformdur.

<h3 style="color: var(--primary-color); margin: 25px 0 15px;">🎯 Özellikler:</h3>
<ul style="list-style-type: none; padding-left: 0;">
  <li style="margin-bottom: 10px;">• Yayınevi admin panelinden kitap yükleme</li>
  <li style="margin-bottom: 10px;">• Kitabın belirli bölümlerini seçme ve link oluşturma</li>
  <li style="margin-bottom: 10px;">• Öğretmenlere dijital kitap inceleme linki gönderme</li>
  <li style="margin-bottom: 10px;">• Güvenli ve kontrollü içerik paylaşımı</li>
  <li style="margin-bottom: 10px;">• İnceleme takibi ve raporlama</li>
</ul>

Yayınevleri İçin Örnek Kitap Uygulaması ile yayınevleri kitaplarını öğretmenlere kolayca sunabilir ve dijital inceleme sürecini yönetebilir.`,
    tags: ['Yayınevi', 'Dijital Kitap', 'Eğitim', 'Platform'],
    faqs: [
      {
        question: 'Yayınevleri İçin Örnek Kitap Uygulaması nasıl çalışır?',
        answer: 'Yayınevi admin panelinden kitabı yükler, inceleme için göndermek istediği bölümleri seçer ve link oluşturur. Bu link öğretmenlere gönderilir ve öğretmenler kitabın dijital versiyonunu inceleyebilir.'
      },
      {
        question: 'Bu uygulama kimler için?',
        answer: 'Yayınevleri İçin Örnek Kitap Uygulaması, eğitim kitapları yayınlayan yayınevleri ve öğretmenlere kitap inceleme fırsatı sunmak isteyen yayıncılar için tasarlanmıştır.'
      }
    ]
  },
  {
    id: 'edtech',
    slug: 'edtech-content-platformu',
    title: 'EdTech İçerik Platformu',
    description: 'Öğretmenlerin içerik geliştirebilecekleri platform',
    shortDescription: 'Öğretmenler için içerik geliştirme platformu',
    category: 'İçerik Geliştirme',
    url: 'https://edtech.progenxacademy.com',
    icon: 'edtech',
    isPopular: false,
    isNew: false,
    content: `EdTech İçerik Platformu, öğretmenlerin eğitim içerikleri geliştirebilecekleri, paylaşabilecekleri ve yönetebilecekleri kapsamlı bir platformdur.

<h3 style="color: var(--primary-color); margin: 25px 0 15px;">🎯 Özellikler:</h3>
<ul style="list-style-type: none; padding-left: 0;">
  <li style="margin-bottom: 10px;">• İnteraktif içerik oluşturma araçları</li>
  <li style="margin-bottom: 10px;">• Çoklu medya desteği (video, ses, görsel)</li>
  <li style="margin-bottom: 10px;">• İçerik paylaşımı ve işbirliği</li>
  <li style="margin-bottom: 10px;">• SCORM uyumlu içerikler</li>
  <li style="margin-bottom: 10px;">• Öğrenci ilerleme takibi</li>
</ul>

EdTech İçerik Platformu ile öğretmenler profesyonel eğitim içerikleri oluşturur ve öğrencilerine sunar.`,
    tags: ['EdTech', 'İçerik', 'Öğretmen', 'Platform'],
    faqs: [
      {
        question: 'EdTech İçerik Platformu kimler için?',
        answer: 'EdTech İçerik Platformu, eğitim içerikleri geliştirmek isteyen öğretmenler, eğitim kurumları ve içerik geliştiricileri için tasarlanmıştır.'
      }
    ]
  },
  {
    id: 'imat',
    slug: 'imat-platformu',
    title: 'İMAT Platformu',
    description: 'İMAT eğitim ve değerlendirme platformu',
    shortDescription: 'İMAT sınavı için özel eğitim platformu',
    category: 'Yurtdışı Eğitimi',
    url: 'https://imat.progenxacademy.com',
    icon: 'academy',
    isPopular: false,
    isNew: false,
    content: `İMAT Platformu, İtalya'da tıp eğitimi almak isteyen öğrenciler için özel olarak tasarlanmış kapsamlı bir hazırlık platformudur.

<h3 style="color: var(--primary-color); margin: 25px 0 15px;">🎯 Özellikler:</h3>
<ul style="list-style-type: none; padding-left: 0;">
  <li style="margin-bottom: 10px;">• İMAT sınavına özel hazırlık materyalleri</li>
  <li style="margin-bottom: 10px;">• Deneme sınavları ve performans analizi</li>
  <li style="margin-bottom: 10px;">• Konu bazlı detaylı çalışma modülleri</li>
  <li style="margin-bottom: 10px;">• İngilizce ve İtalyanca dil desteği</li>
  <li style="margin-bottom: 10px;">• Uzman öğretmenlerden canlı dersler</li>
  <li style="margin-bottom: 10px;">• İlerleme takibi ve kişiselleştirilmiş öneriler</li>
</ul>

İMAT Platformu ile İtalya'da tıp okuma hayalinizi gerçeğe dönüştürün.`,
    tags: ['İMAT', 'Tıp', 'Sınav Hazırlık', 'İtalya'],
    faqs: [
      {
        question: 'İMAT Platformu nedir?',
        answer: 'İMAT Platformu, İtalya\'da tıp fakültelerine giriş sınavı olan İMAT\'a hazırlık için özel olarak tasarlanmış kapsamlı bir eğitim platformudur.'
      },
      {
        question: 'İMAT Platformu kimler için uygun?',
        answer: 'İMAT Platformu, İtalya\'da tıp eğitimi almak isteyen ve İMAT sınavına hazırlanan tüm öğrenciler için uygundur.'
      }
    ]
  },
  {
    id: 'alevel',
    slug: 'a-level-platformu',
    title: 'A-Level Platformu',
    description: 'A-Level sınavlarına hazırlık için kapsamlı eğitim platformu',
    shortDescription: 'A-Level sınavlarına özel hazırlık platformu',
    category: 'Yurtdışı Eğitimi',
    url: 'https://alevel.progenxacademy.com',
    icon: 'academy',
    isPopular: false,
    isNew: false,
    content: `A-Level Platformu, İngiltere ve diğer ülkelerde üniversite eğitimi almak isteyen öğrenciler için A-Level sınavlarına hazırlık sunan kapsamlı bir eğitim platformudur.

<h3 style="color: var(--primary-color); margin: 25px 0 15px;">🎯 Özellikler:</h3>
<ul style="list-style-type: none; padding-left: 0;">
  <li style="margin-bottom: 10px;">• A-Level müfredatına uygun içerikler</li>
  <li style="margin-bottom: 10px;">• Tüm A-Level dersleri için hazırlık materyalleri</li>
  <li style="margin-bottom: 10px;">• Geçmiş yıllara ait sınav soruları ve çözümleri</li>
  <li style="margin-bottom: 10px;">• Deneme sınavları ve performans analizi</li>
  <li style="margin-bottom: 10px;">• Uzman öğretmenlerden canlı dersler</li>
  <li style="margin-bottom: 10px;">• İlerleme takibi ve kişiselleştirilmiş öğrenme planları</li>
</ul>

A-Level Platformu ile İngiltere ve dünya çapında üniversite eğitimi için gerekli A-Level sınavlarına en iyi şekilde hazırlanın.`,
    tags: ['A-Level', 'Yurtdışı Eğitim', 'Sınav Hazırlık', 'İngiltere'],
    faqs: [
      {
        question: 'A-Level Platformu nedir?',
        answer: 'A-Level Platformu, İngiltere ve diğer ülkelerde üniversite eğitimi almak isteyen öğrenciler için A-Level sınavlarına hazırlık sunan kapsamlı bir eğitim platformudur.'
      },
      {
        question: 'A-Level Platformu kimler için uygun?',
        answer: 'A-Level Platformu, İngiltere veya A-Level sistemini kullanan ülkelerde üniversite eğitimi almak isteyen ve A-Level sınavlarına hazırlanan tüm öğrenciler için uygundur.'
      }
    ]
  },
  {
    id: 'sat',
    slug: 'sat-platformu',
    title: 'SAT Platformu',
    description: 'SAT sınavına hazırlık için kapsamlı eğitim platformu',
    shortDescription: 'SAT sınavına özel hazırlık platformu',
    category: 'Yurtdışı Eğitimi',
    url: 'https://sat.progenxacademy.com',
    icon: 'academy',
    isPopular: false,
    isNew: false,
    content: `SAT Platformu, Amerika Birleşik Devletleri ve diğer ülkelerde üniversite eğitimi almak isteyen öğrenciler için SAT sınavına hazırlık sunan kapsamlı bir eğitim platformudur.

<h3 style="color: var(--primary-color); margin: 25px 0 15px;">🎯 Özellikler:</h3>
<ul style="list-style-type: none; padding-left: 0;">
  <li style="margin-bottom: 10px;">• SAT sınavına özel hazırlık materyalleri</li>
  <li style="margin-bottom: 10px;">• Matematik, Okuma ve Yazma bölümleri için detaylı içerikler</li>
  <li style="margin-bottom: 10px;">• Geçmiş yıllara ait SAT soruları ve çözümleri</li>
  <li style="margin-bottom: 10px;">• Deneme sınavları ve performans analizi</li>
  <li style="margin-bottom: 10px;">• Strateji ve ipuçları ile sınav teknikleri</li>
  <li style="margin-bottom: 10px;">• İlerleme takibi ve kişiselleştirilmiş öğrenme planları</li>
</ul>

SAT Platformu ile Amerika'da üniversite eğitimi için gerekli SAT sınavına en iyi şekilde hazırlanın.`,
    tags: ['SAT', 'Yurtdışı Eğitim', 'Sınav Hazırlık', 'Amerika'],
    faqs: [
      {
        question: 'SAT Platformu nedir?',
        answer: 'SAT Platformu, Amerika Birleşik Devletleri ve diğer ülkelerde üniversite eğitimi almak isteyen öğrenciler için SAT sınavına hazırlık sunan kapsamlı bir eğitim platformudur.'
      },
      {
        question: 'SAT Platformu kimler için uygun?',
        answer: 'SAT Platformu, Amerika\'da veya SAT sınavını kabul eden ülkelerde üniversite eğitimi almak isteyen ve SAT sınavına hazırlanan tüm öğrenciler için uygundur.'
      }
    ]
  },
  {
    id: 'ap',
    slug: 'ap-platformu',
    title: 'AP Platformu',
    description: 'Advanced Placement (AP) sınavlarına hazırlık için kapsamlı eğitim platformu',
    shortDescription: 'AP sınavlarına özel hazırlık platformu',
    category: 'Yurtdışı Eğitimi',
    url: 'https://ap.progenxacademy.com',
    icon: 'academy',
    isPopular: false,
    isNew: false,
    content: `AP Platformu, Amerika Birleşik Devletleri ve diğer ülkelerde üniversite eğitimi almak isteyen öğrenciler için Advanced Placement (AP) sınavlarına hazırlık sunan kapsamlı bir eğitim platformudur.

<h3 style="color: var(--primary-color); margin: 25px 0 15px;">🎯 Özellikler:</h3>
<ul style="list-style-type: none; padding-left: 0;">
  <li style="margin-bottom: 10px;">• Tüm AP dersleri için hazırlık materyalleri</li>
  <li style="margin-bottom: 10px;">• AP Calculus, AP Biology, AP Chemistry, AP Physics ve daha fazlası</li>
  <li style="margin-bottom: 10px;">• Geçmiş yıllara ait AP sınav soruları ve çözümleri</li>
  <li style="margin-bottom: 10px;">• Deneme sınavları ve performans analizi</li>
  <li style="margin-bottom: 10px;">• Uzman öğretmenlerden canlı dersler</li>
  <li style="margin-bottom: 10px;">• İlerleme takibi ve kişiselleştirilmiş öğrenme planları</li>
</ul>

AP Platformu ile Amerika'da üniversite eğitimi için gerekli AP sınavlarına en iyi şekilde hazırlanın ve üniversite kredisi kazanın.`,
    tags: ['AP', 'Advanced Placement', 'Yurtdışı Eğitim', 'Sınav Hazırlık', 'Amerika'],
    faqs: [
      {
        question: 'AP Platformu nedir?',
        answer: 'AP Platformu, Amerika Birleşik Devletleri ve diğer ülkelerde üniversite eğitimi almak isteyen öğrenciler için Advanced Placement (AP) sınavlarına hazırlık sunan kapsamlı bir eğitim platformudur.'
      },
      {
        question: 'AP Platformu kimler için uygun?',
        answer: 'AP Platformu, Amerika\'da veya AP sınavlarını kabul eden ülkelerde üniversite eğitimi almak isteyen ve AP sınavlarına hazırlanan tüm öğrenciler için uygundur.'
      }
    ]
  },
  {
    id: 'act',
    slug: 'act-platformu',
    title: 'ACT Platformu',
    description: 'ACT sınavına hazırlık için kapsamlı eğitim platformu',
    shortDescription: 'ACT sınavına özel hazırlık platformu',
    category: 'Yurtdışı Eğitimi',
    url: 'https://act.progenxacademy.com',
    icon: 'academy',
    isPopular: false,
    isNew: false,
    content: `ACT Platformu, Amerika Birleşik Devletleri ve diğer ülkelerde üniversite eğitimi almak isteyen öğrenciler için ACT sınavına hazırlık sunan kapsamlı bir eğitim platformudur.

<h3 style="color: var(--primary-color); margin: 25px 0 15px;">🎯 Özellikler:</h3>
<ul style="list-style-type: none; padding-left: 0;">
  <li style="margin-bottom: 10px;">• ACT sınavına özel hazırlık materyalleri</li>
  <li style="margin-bottom: 10px;">• İngilizce, Matematik, Okuma ve Bilim bölümleri için detaylı içerikler</li>
  <li style="margin-bottom: 10px;">• Geçmiş yıllara ait ACT soruları ve çözümleri</li>
  <li style="margin-bottom: 10px;">• Deneme sınavları ve performans analizi</li>
  <li style="margin-bottom: 10px;">• Strateji ve ipuçları ile sınav teknikleri</li>
  <li style="margin-bottom: 10px;">• İlerleme takibi ve kişiselleştirilmiş öğrenme planları</li>
</ul>

ACT Platformu ile Amerika'da üniversite eğitimi için gerekli ACT sınavına en iyi şekilde hazırlanın.`,
    tags: ['ACT', 'Yurtdışı Eğitim', 'Sınav Hazırlık', 'Amerika'],
    faqs: [
      {
        question: 'ACT Platformu nedir?',
        answer: 'ACT Platformu, Amerika Birleşik Devletleri ve diğer ülkelerde üniversite eğitimi almak isteyen öğrenciler için ACT sınavına hazırlık sunan kapsamlı bir eğitim platformudur.'
      },
      {
        question: 'ACT Platformu kimler için uygun?',
        answer: 'ACT Platformu, Amerika\'da veya ACT sınavını kabul eden ülkelerde üniversite eğitimi almak isteyen ve ACT sınavına hazırlanan tüm öğrenciler için uygundur.'
      }
    ]
  }
];

// Helper function to get application by slug
export const getApplicationBySlug = (slug) => {
  return applications.find(app => app.slug === slug);
};

// Helper function to get all application slugs
export const getAllApplicationSlugs = () => {
  return applications.map(app => app.slug);
};
